import Button from '@result/result-ui-components/src/components/Button';
import React, { useEffect } from 'react';

const Modal = (props) => {
	useEffect(() => {
		const close = (e) => {
			if (e.keyCode === 27) {
				props.onCancel();
			}
		};
		window.addEventListener('keydown', close);
		return () => window.removeEventListener('keydown', close);
	}, []);

	if (!props.showPopup) {
		return null;
	}

	return (
		<div
			className={`modal ${props.showPopup ? 'is-active' : ''}`}
			onClick={props.onCancel}>
			<div className={'modal-card'} onClick={(e) => e.stopPropagation()}>
				<div className={'modal-card-head'}>
					<h1 className={'modal-card-title'}>{props.title}</h1>
				</div>
				<div>
					<section className={'modal-card-body'}>{props.content}</section>
					<div className={'modal-card-foot'}>
						{props.onCancel && (
							<Button
								color={props.cancelButton ?? 'danger'}
								label={props.cancelButtonLabel}
								onClick={props.onCancel}
								isLoading={props.isLoading ?? false}
							/>
						)}
						{props.onConfirm && (
							<Button
								color="primary"
								isOutlined={true}
								label={props.confirmButtonLabel}
								onClick={props.onConfirm}
								isLoading={props.isLoading ?? false}
							/>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Modal;
